'use strict'

import _ from 'lodash'
import SendBirdAdapter from './adapter.js'
import Element from './elements/element.js'
import Spinner from './elements/spinner.js'
import ChatBoard from './elements/chat-board.js'
import LoginBoard from './elements/login-board.js'
import MessageBoard from './elements/message-board.js'

function getUUID() {
  // UUID v4 generator in JavaScript (RFC4122 compliant)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0
    var v = c == 'x' ? r : (r & 3) | 8
    return v.toString(16)
  })
}
const ELEMENT_ID = 'sb_chat'
const ERROR_MESSAGE_APP_ID = 'Please pass "APP_ID" when start.'
const ERROR_MESSAGE_USER_INFO =
  'Please pass "USER_ID" and "NICKNAME" when start.'
const ERROR_MESSAGE_CHANNEL_URL = 'Please pass "CHANNEL_URL" when start.'
const ERROR_MESSAGE = 'Please create "sb_chat" element on first.'

const MAX_MESSAGE_COUNT = 100

window.WebFontConfig = {
  google: { families: ['Lato:400,700'] },
}

export default class LiveChat {
  // eslint-disable-next-line no-useless-constructor
  // constructor () {
  // }
  constructor({
    chatSubTitle = '',
    chatInputPlaceHolder = '',
    chatInputExample = '',
    companyName = '',
  }) {
    this.chatSubTitle = chatSubTitle
    this.chatInputPlaceHolder = chatInputPlaceHolder
    this.chatInputExample = chatInputExample
    this.companyName = companyName
  }

  init(appId, arg) {
    if (!appId) {
      console.error(ERROR_MESSAGE_APP_ID)
      return
    }
    switch (arg.type) {
      case 'channel':
        if (!arg.data.channelUrl) {
          console.error(ERROR_MESSAGE_CHANNEL_URL)
          return
        }
        break
      case 'user':
        if (!arg.data.userId || !arg.data.nickname) {
          console.error(ERROR_MESSAGE_USER_INFO)
          return
        }
        break
    }
    this.loadGoogleFont()

    let _this = this
    this.$chat = new Element(document.getElementById(ELEMENT_ID))
    if (this.$chat) {
      this.adapter = new SendBirdAdapter(appId)
      this.$spinner = new Spinner()
      this.$chatBoard = new ChatBoard(this.$chat)
      this.$messageBoard = new MessageBoard(this)

      // eslint-disable-next-line no-inner-declarations
      function isBottom() {
        const portraitTest =
          window.innerHeight + window.scrollY - document.body.scrollHeight > -15
        const landscapeTest =
          _this.$chatBoard.$.clientHeight -
            (_this.$chatBoard.$.scrollHeight - _this.$chatBoard.$.scrollTop) >
          -15
        return portraitTest && landscapeTest
      }

      // eslint-disable-next-line no-inner-declarations
      function onScrollFn() {
        let scrollY = window.scrollY || _this.$chatBoard.getScrollY()
        if (isBottom()) {
          _this.$messageBoard.removeBottomBar()
        } else {
          _this.$messageBoard.createBottomBar()
        }
        if (scrollY < 50) {
          if (_this.$chatBoard.$.offsetParent === null) return
          _this.$messageBoard.$contentInput.appendElement(_this.$spinner.$)
          _this.adapter.getMessageList((messageList) => {
            _this.$messageBoard.render(messageList, false, true)
            _this.$messageBoard.$contentInput.removeElement(_this.$spinner.$)
          })
        }
      }
      const debounceFn = _.debounce(onScrollFn, 500)
      this.$chatBoard.on('scroll', debounceFn)
      window.addEventListener('scroll', debounceFn)

      _this.$messageBoard.$icon.on('click', () => {
        let textMessage = _this.$messageBoard.getMessage()
        _this.$messageBoard.clearInput()
        if (textMessage) {
          textMessage = textMessage.replace(/<[\/]?\s*br\s*[\/]?>/gi, '\n')
          _this.adapter.sendMessage(textMessage, (message) => {
            _this.$messageBoard.render([message], true, false)
            _this.clearOverflowedMessages()
            _this.scrollToBottom()
          })
        }
      })
    }
  }
  goBottom() {
    window.scrollTo(0, document.body.scrollHeight)
    this.$chatBoard.scrollY(this.$chatBoard.$.scrollHeight)
  }

  start(appId, channelUrl) {
    this.init(appId, {
      type: 'channel',
      data: {
        channelUrl: channelUrl,
      },
    })

    if (this.$chat) {
      let _this = this
      this.$loginBoard = new LoginBoard(_this)
      this.$loginBoard.onLogin(() => {
        if (_this.$loginBoard.$nickname.val().length < 2) {
          alert('대화명을 입력해 주세요.')
          return
        }
        if (!/^[가-힣a-zA-Z\s]+$/g.test(_this.$loginBoard.$nickname.val())) {
          alert('대화명을 다시 입력해 주세요. 한글,영어로만 입력 가능합니다.')
          return
        }

        if (!_this.$loginBoard.$login.hasClass('disabled')) {
          _this.$loginBoard.disable()
          _this.$spinner.attachTo(_this.$loginBoard.$login)
          var uuid = getUUID()
          _this.adapter.connect(
            uuid,
            this.companyName + _this.$loginBoard.$nickname.val(),
            () => {
              _this.$spinner.remove(_this.$loginBoard.$login)
              _this.$loginBoard.reset()
              _this.$spinner.attachTo(_this.$messageBoard.$content)

              _this.$chatBoard.replaceElement(
                _this.$loginBoard,
                _this.$messageBoard,
              )
              _this.adapter.connectionHandler(channelUrl, _this)
              _this.enterChannel(channelUrl)
            },
          )
        }
      })
      this.$chatBoard.appendElement(this.$loginBoard)
    } else {
      console.error(ERROR_MESSAGE)
    }
  }

  startWithConnect(appId, userId, nickname, callback) {
    let _this = this
    _this.init(appId, {
      type: 'user',
      data: {
        userId: userId,
        nickname: nickname,
      },
    })
    if (_this.$chat) {
      _this.adapter.connect(userId, nickname, () => {
        _this.$spinner.attachTo(_this.$messageBoard.$content)
        _this.$chatBoard.appendElement(_this.$messageBoard)
        callback()
      })
    } else {
      console.error(ERROR_MESSAGE)
    }
  }

  enterChannel(channelUrl, callback) {
    let _this = this
    _this.adapter.enterChannel(channelUrl, () => {
      _this.adapter.getMessageList((messageList) => {
        _this.$spinner.remove(_this.$messageBoard.$content)
        _this.$messageBoard.render(messageList, true, false)
        _this.goBottom()
        _this.adapter.createHandler((channel, message) => {
          if (channel.url === channelUrl) {
            const isBottom = this.isMessageBottom()
            _this.$messageBoard.render([message], isBottom, false)
            if (!isBottom) {
              _this.$messageBoard.createBottomBar()
            } else {
              this.goBottom()
            }
          }
        })
      }, true)
      if (callback) {
        callback()
      }
    })
  }

  exitChannel(callback) {
    this.adapter.exitChannel(callback)
  }

  clearOverflowedMessages() {
    let $messages = this.$messageBoard.$content.children()
    let overCount = $messages.length - MAX_MESSAGE_COUNT
    if (overCount > 0) {
      for (let i = 0; i < overCount; i++) {
        this.$messageBoard.$content.removeFirst()
      }
    }
  }

  scrollToBottom() {
    window.scrollTo(0, document.body.scrollHeight)
    this.$chatBoard.scrollToBottom()
  }

  isMessageBottom() {
    return document.querySelector('.view-more-area.btn.btn-primary') === null
    // if(viewMoreButton) {}
    // const isBottomCheck1 = (window.innerHeight + window.scrollY) - document.body.scrollHeight
    // return (isBottomCheck1 >= -10 && isBottomCheck1 <= 10) && (this.$chatBoard.$.scrollHeight - this.$chatBoard.$.scrollTop === this.$chatBoard.$.clientHeight)
  }

  loadGoogleFont() {
    var wf = document.createElement('script')
    wf.src =
      (document.location.protocol == 'https:' ? 'https' : 'http') +
      '://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js'
    wf.type = 'text/javascript'
    wf.async = 'true'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(wf, s)
  }
}
// window.liveChat = new LiveChat()
